<template>
    <div class="checkbox-container" @click="onChange">
        <span class="checkbox-title">{{ title }}</span>
        <span type="checkbox" class="widget_checkbox">
            <span class="checkbox-checkmark" :class="{ active: value }"></span>
        </span>

    </div>
</template>

<script>
export default {
    name: "widget_checkbox",
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "",
        },
    },
    data() {
        return {};
    },
    watch: {},
    mounted() { },
    methods: {
        onChange() {
            let vm = this;
            vm.$emit("input", !vm.value);
            vm.$emit("change", !vm.value);
        },
    },
};
</script>
<style lang="scss" scoped>
.checkbox-container {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;

    .widget_checkbox {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 14px;
        height: 14px;
        border: 1px solid #ccc;
        border-radius: 2px;
        background-color: #fff;
        margin-left: 8px;

        &:hover {
            background-color: #f5f5f5;
        }

        .checkbox-checkmark {
            width: 11px;
            height: 11px;
            background-color: rgba(27, 165, 164, 1);
            visibility: hidden;
            opacity: 0;
            transform: scale(0.5);
            transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

            &.active {
                visibility: visible;
                opacity: 1;
                transform: scale(1);
            }
        }
    }

    .checkbox-title {
        font-size: 12px;
        color: rgba(8, 132, 175, 1);
    }
}
</style>